export default {
  GET_LIST: '/manage/aboutBasf/list',
  ADD_ABOUT_BASF: '/manage/aboutBasf/add',
  GET_DETAIL: '/manage/aboutBasf/detail',
  CHECK_EMAIL: '/manage/aboutBasf/checkEmail',
  CHECK_WEIGHT: '/manage/aboutBasf/checkweight',
  UPDATE_HIDDEN: '/manage/aboutBasf/updateHidden',
  EDIT_ABOUT_BASF: '/manage/aboutBasf/update',
  EXPORT_LIST: '/manage/aboutBasf/exportList'
}


// WEBPACK FOOTER //
// ./src/axios/api_urls/aboutBASF.js